import React from "react";

import { Box } from "@mui/material";

export function NoResultsOverlay() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <Box sx={{ mt: 1 }}>No results found.</Box>
    </Box>
  );
}
